import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/quotes_/$quoteId/")({
  component: NoTaskOpen,
})

function NoTaskOpen(): React.ReactElement {
  return <span />
}
